(() => {
  const storageKey = 'civico_cookie_consent_v1';
  const maxAgeMs = 180 * 24 * 60 * 60 * 1000;
  const emptyConsent = {
    preferences: false,
    analytics: false,
    marketing: false,
    sale_of_data: false,
  };

  const queue = (window.civicoConsentQueue = window.civicoConsentQueue || []);
  let apiReady = false;

  const readStoredConsent = () => {
    try {
      const stored = JSON.parse(window.localStorage.getItem(storageKey) || 'null');
      if (!stored || !stored.createdAt || Date.now() - stored.createdAt > maxAgeMs) {
        return null;
      }

      return {
        ...emptyConsent,
        ...stored.consent,
      };
    } catch (error) {
      return null;
    }
  };

  const writeStoredConsent = (consent) => {
    window.localStorage.setItem(
      storageKey,
      JSON.stringify({
        consent,
        createdAt: Date.now(),
      }),
    );
  };

  const hasDecision = () => Boolean(readStoredConsent());

  const isAllowed = (purposes = []) => {
    const consent = readStoredConsent();
    if (!consent) return false;

    const requiredPurposes = Array.isArray(purposes) ? purposes : [purposes];
    return requiredPurposes.every((purpose) => consent[purpose] === true);
  };

  const dispatchConsent = () => {
    document.dispatchEvent(
      new CustomEvent('civico:consent-updated', {
        detail: {
          consent: readStoredConsent(),
        },
      }),
    );
  };

  const drainQueue = () => {
    for (let index = queue.length - 1; index >= 0; index -= 1) {
      const item = queue[index];
      if (!item || item.length < 2) continue;

      const [purposes, callback] = item;
      if (typeof callback === 'function' && isAllowed(purposes)) {
        queue.splice(index, 1);
        callback();
      }
    }
  };

  window.civicoConsent = {
    isAllowed,
    whenAllowed(purposes, callback) {
      if (isAllowed(purposes)) {
        callback();
        return;
      }

      queue.push([purposes, callback]);
    },
    current() {
      return readStoredConsent();
    },
  };

  window.civicoConsentWhenAllowed = (purposes, callback) => {
    window.civicoConsent.whenAllowed(purposes, callback);
  };

  const loadPrivacyApi = (callback, attempts = 0) => {
    if (window.Shopify?.customerPrivacy) {
      apiReady = true;
      callback(window.Shopify.customerPrivacy);
      return;
    }

    if (window.Shopify?.loadFeatures) {
      window.Shopify.loadFeatures(
        [
          {
            name: 'consent-tracking-api',
            version: '0.1',
          },
        ],
        (error) => {
          apiReady = !error && Boolean(window.Shopify?.customerPrivacy);
          callback(window.Shopify?.customerPrivacy);
        },
      );
      return;
    }

    if (attempts < 30) {
      window.setTimeout(() => loadPrivacyApi(callback, attempts + 1), 100);
      return;
    }

    callback(null);
  };

  const root = document.querySelector('[data-civico-cookie]');
  const modal = document.querySelector('[data-civico-cookie-modal]');
  const checkboxes = Array.from(document.querySelectorAll('[data-civico-cookie-purpose]'));

  if (!root || !modal) return;

  const showBanner = () => {
    root.hidden = false;
  };

  const hideBanner = () => {
    root.hidden = true;
  };

  const openModal = () => {
    const currentConsent = readStoredConsent() || emptyConsent;
    checkboxes.forEach((checkbox) => {
      checkbox.checked = currentConsent[checkbox.dataset.civicoCookiePurpose] === true;
    });
    modal.hidden = false;
  };

  const closeModal = () => {
    modal.hidden = true;
  };

  const selectedConsent = () =>
    checkboxes.reduce(
      (consent, checkbox) => ({
        ...consent,
        [checkbox.dataset.civicoCookiePurpose]: checkbox.checked,
      }),
      { ...emptyConsent },
    );

  const applyConsent = (consent) => {
    writeStoredConsent(consent);

    const finish = () => {
      hideBanner();
      closeModal();
      dispatchConsent();
      drainQueue();
    };

    if (apiReady && window.Shopify?.customerPrivacy?.setTrackingConsent) {
      window.Shopify.customerPrivacy.setTrackingConsent(consent, finish);
      return;
    }

    loadPrivacyApi((api) => {
      if (api?.setTrackingConsent) {
        api.setTrackingConsent(consent, finish);
      } else {
        finish();
      }
    });
  };

  const acceptAll = () =>
    applyConsent({
      preferences: true,
      analytics: true,
      marketing: true,
      sale_of_data: true,
    });

  const rejectAll = () => applyConsent({ ...emptyConsent });

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-civico-cookie-open]');
    if (openButton) {
      event.preventDefault();
      openModal();
      return;
    }

    const closeButton = event.target.closest('[data-civico-cookie-close]');
    if (closeButton) {
      event.preventDefault();
      closeModal();
      return;
    }

    const actionButton = event.target.closest('[data-civico-cookie-action]');
    if (!actionButton) return;

    event.preventDefault();

    if (actionButton.dataset.civicoCookieAction === 'accept') {
      acceptAll();
    } else if (actionButton.dataset.civicoCookieAction === 'reject') {
      rejectAll();
    } else if (actionButton.dataset.civicoCookieAction === 'save') {
      applyConsent(selectedConsent());
    }
  });

  loadPrivacyApi(() => {
    if (!hasDecision()) {
      showBanner();
    } else {
      drainQueue();
    }
  });
})();
